import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import config from '../variables/config'

export const PLAYONLY_REQUIRED = 'bookings/PLAYONLY_REQUIRED'
export const PARTY_REQUIRED = 'bookings/PARTY_REQUIRED'
export const NOT_REQUIRED = 'bookings/NOT_REQUIRED'
export const REQUEST_FINISHED = 'bookings/REQUEST_FINISHED'
export const REQUEST_FAILED = 'bookings/REQUEST_FAILED'
export const REQUEST_SENT = 'bookings/REQUEST_SENT'
export const CHANGE_FINISHED = 'bookings/CHANGE_FINISHED'
export const FETCH_PARTY = 'bookings/FETCH_PARTY'
export const FETCH_PLAY = 'bookings/FETCH_PLAY'
export const FETCH_PARTY_DONE = 'bookings/FETCH_PARTY_DONE'
export const FETCH_PLAY_DONE = 'bookings/FETCH_PLAY_DONE'
export const FETCH_CLASS_DONE = 'bookings/FETCH_CLASS_DONE'
export const FETCH_DATES = 'bookings/FETCH_DATES'
export const FETCH_CLASS = 'bookings/FETCH_CLASS'
export const FETCH_DATES2 = 'bookings/FETCH_DATES2'
export const FETCH_AGES = 'bookings/FETCH_AGES'

const initialState = {
  requestedUser: {
    partyBookings: [],
    playonlyBookings: [],
    classBookings: []
  },
  partyBookings: [],
  playonlyBookings: [],
  classBookings: [],
  fetchPlayDone: false,
  fetchPartyDone: false,
  fetchClassDone: false,
  bookingDates: [],
  bookingDates2: [],
  ages: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FINISHED:
      return {
        ...state,
        requestLoading: false,
        requestFinished: true,
        [action.property]: action.data
      }

    case FETCH_PARTY:
      return {
        ...state,
        fetchPartyDone: true,
        partyBookings: action.data
      }

    case FETCH_PLAY:
      return {
        ...state,
        fetchPlayDone: true,
        playonlyBookings: action.data
      }

    case FETCH_CLASS:
      return {
        ...state,
        fetchClassDone: true,
        classBookings: action.data
      }

    case FETCH_PARTY_DONE:
      return {
        ...state,
        fetchPartyDone: false
      }

    case FETCH_PLAY_DONE:
      return {
        ...state,
        fetchPlayDone: false
      }

    case FETCH_CLASS_DONE:
      return {
        ...state,
        fetchClassDone: false
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case CHANGE_FINISHED:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    case FETCH_DATES:
      return {
        ...state,
        bookingDates: action.data
      }

    case FETCH_DATES2:
      return {
        ...state,
        bookingDates2: action.data
      }

    case FETCH_AGES:
      return {
        ...state,
        ages: action.data
      }
    default:
      return state
  }
}

export const fetchClass = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token

    try {
      dispatch({ type: REQUEST_SENT })
      const ops = getOptions(token, data, 'classDate')
      const classBookings = (await axios.get(
        config.serverURL + '/ClassBooking' + config.endpoint,
        ops
      )).data

      classBookings.sort(function(playOne, playTwo) {
        var dateOne = moment(playOne.orderDate)
        var dateTwo = moment(playTwo.orderDate)

        if (dateOne.isBefore(dateTwo)) return -1

        if (dateOne.isBefore(dateTwo)) return 1

        return 0
      })
      const state = getState()
      var { users } = state.users
      const classIds = state.bookings.classBookings.map(item => item.wKUserId);
      const classIdsOnsite = state.bookings.classBookings.map(item => item.onsiteUserId);
  
      const IDstringify = JSON.stringify(classIds);
      const IDstringifyOnsite = JSON.stringify(classIdsOnsite);
  
      // const checks = await axios.get(
      //   config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringify +'}}}&access_token=' + token
      // )
  
      // const checksOnsite = await axios.get(
      //   config.serverURL + '/OnsiteUsers?filter={"where":{"id":{"inq":' + IDstringifyOnsite +'}}, "include":["membership","guardians"]}&access_token=' + token
      // )
  
      // const users = checks.data.concat(checksOnsite.data);

      classBookings.forEach(play => {
        users.forEach(user => {
          if (play.onsiteUserId && user.id === play.onsiteUserId) {
            play.user = user
          }

          if (play.wKUserId && user.id === play.wKUserId) {
            play.user = user
          }
        })

        if (!play.user) {
          play.user = {
            firstName: 'Not',
            lastName: 'Found'
          }
        }
      })

      dispatch({
        type: FETCH_CLASS,
        data: classBookings
      })
    } catch (error) {
      console.log('bookings - fetchPlayonly:', error.message)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

function getOptions(token, data, prop) {
  let options = {
    query: {
      access_token: token
    }
  }

  if (data && data.date) {
    const endDate = data.date.clone().endOf('week')
    endDate.add(1, 'days')
    const startDate = data.date.clone().startOf('week')
    startDate.set({ hour: 22, minute: 59 })

    options.params = {
      filter: {
        where: {
          and: [
            { [prop]: { lt: new Date(endDate.format()) } },
            { [prop]: { gt: new Date(startDate.format()) } }
          ]
        }
      }
    }
  }

  return options
}


function getOptionsMonth(token, data, prop) {
  let options = {
    query: {
      access_token: token
    }
  }
  if (data && data.date) {
    const endDate = data.date.clone().endOf('month')
    endDate.add(1, 'days')
    const startDate = data.date.clone().startOf('month')
    startDate.set({ hour: 22, minute: 59 })

    options.params = {
      filter: {
        where: {
          and: [
            { [prop]: { lt: new Date(endDate.format()) } },
            { [prop]: { gt: new Date(startDate.format()) } }
          ]
        }
      }
    }
  }

  return options
}

export const getAgeStats = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token

    try {
      dispatch({ type: REQUEST_SENT })

      const ops = getOptions(token, data, 'date')
      const playonlyBookings = (await axios.get(
        config.serverURL + '/PlayOnlyBooking' + config.endpoint,
        ops
      )).data

      playonlyBookings.sort(function(playOne, playTwo) {
        var dateOne = moment(playOne.date)
        var timeOne = moment(playOne.time.split(' - ')[0], 'h:mm A')
          .format('HH:mm')
          .split(':')
        dateOne.set({ h: Number(timeOne[0]), m: Number(timeOne[1]) })

        var dateTwo = moment(playTwo.date)
        var timeTwo = moment(playTwo.time.split(' - ')[0], 'h:mm A')
          .format('HH:mm')
          .split(':')
        dateTwo.set({ h: Number(timeTwo[0]), m: Number(timeTwo[1]) })

        if (dateOne.isBefore(dateTwo)) return -1

        if (dateOne.isBefore(dateTwo)) return 1

        return 0
      })

      let under12months = 0
      let oneYearOlds = 0
      let twoToThree = 0
      let fourAndOver = 0
      let adults = 0

      playonlyBookings.forEach(booking => {
        under12months += booking.visitorDetails.under12mnths.length
        oneYearOlds += booking.visitorDetails.oneYearOlds.length
        twoToThree += booking.visitorDetails.twoToThree.length
        fourAndOver += booking.visitorDetails.fourAndOver.length
        adults += booking.visitorDetails.adults.length
      })

      const ageStats = {
        under12months,
        oneYearOlds,
        twoToThree,
        fourAndOver,
        adults
      }

      dispatch({ type: FETCH_AGES, data: ageStats })
    } catch (error) {
      console.log('bookings - getAgeStats:', error.message)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const fetchPlayonly = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token

    try {
      dispatch({ type: REQUEST_SENT })

      const ops = getOptions(token, data, 'date')
      const playonlyBookings = (await axios.get(
        config.serverURL + '/PlayOnlyBooking' + config.endpoint,
        ops
      )).data

      playonlyBookings.sort(function(playOne, playTwo) {
        var dateOne = moment(playOne.date)
        var timeOne = moment(playOne.time.split(' - ')[0], 'h:mm A')
          .format('HH:mm')
          .split(':')
        dateOne.set({ h: Number(timeOne[0]), m: Number(timeOne[1]) })

        var dateTwo = moment(playTwo.date)
        var timeTwo = moment(playTwo.time.split(' - ')[0], 'h:mm A')
          .format('HH:mm')
          .split(':')
        dateTwo.set({ h: Number(timeTwo[0]), m: Number(timeTwo[1]) })

        if (dateOne.isBefore(dateTwo)) return -1

        if (dateOne.isBefore(dateTwo)) return 1

        return 0
      })

      dispatch({
        type: FETCH_PLAY,
        data: playonlyBookings
      })
    } catch (error) {
      console.log('bookings - fetchPlayonly:', error.message)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const clearFetchPlay = data => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_PLAY_DONE })
  }
}

export const clearFetchClass = data => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_CLASS_DONE })
  }
}

export const fetchParty = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      dispatch({ type: REQUEST_SENT })

      const ops = getOptions(token, data, 'partyDate')
      var partyBookings = (await axios.get(
        config.serverURL + '/PartyBooking' + config.endpoint,
        ops
      )).data

      partyBookings = partyBookings.filter(party => {
        return party.reference !== 'WKPBReservation'
      })

      partyBookings.sort(function(partyOne, partyTwo) {
        var dateOne = moment(partyOne.partyDate)
        var timeOne = moment(partyOne.partyTime.split(' - ')[0], 'h:mm A')
          .format('HH:mm')
          .split(':')
        dateOne.set({ h: Number(timeOne[0]), m: Number(timeOne[1]) })

        var dateTwo = moment(partyTwo.partyDate)
        var timeTwo = moment(partyTwo.partyTime.split(' - ')[0], 'h:mm A')
          .format('HH:mm')
          .split(':')
        dateTwo.set({ h: Number(timeTwo[0]), m: Number(timeTwo[1]) })

        if (dateOne.isBefore(dateTwo)) return -1

        if (dateOne.isBefore(dateTwo)) return 1

        return 0
      })

      dispatch({
        type: FETCH_PARTY,
        data: partyBookings
      })
    } catch (error) {
      console.log('bookings - fetchParty:', error.message)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const clearFetchParty = data => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_PARTY_DONE })
  }
}

export const setUsers = data => {
  return async (dispatch, getState) => {
    const state = getState();
    const token = getState().admin.token
    const partyIds = state.bookings.partyBookings.map(item => item.wKUserId).concat(state.bookings.partyBookings.map(item => item.onsiteUserId));
    const partyIdsOnsite = state.bookings.partyBookings.map(item => item.onsiteUserId);
    // const playWithinOneDay = state.bookings.playonlyBookings.filter(item => moment(item.date).diff(data, 'days') <= 1 && 0 <= moment(item.date).diff(data, 'days'));
    // try to limit booking with in days but it does not work well
    const playIds = state.bookings.playonlyBookings.map(item => item.wKUserId).concat(state.bookings.playonlyBookings.map(item => item.onsiteUserId));
    const playIdsOnsite = state.bookings.playonlyBookings.map(item => item.onsiteUserId);
    const classIds = state.bookings.classBookings.map(item => item.wKUserId).concat(state.bookings.classBookings.map(item => item.onsiteUserId));
    const classIdsOnsite = state.bookings.classBookings.map(item => item.onsiteUserId);

    const partyIdsShorten = partyIds.filter(id => id);
    const partyIdsOnsiteShorten = partyIdsOnsite.filter(id => id);
    const playIdsShorten = playIds.filter(id => id);
    const playIdsOnsiteShorten = playIdsOnsite.filter(id => id);
    const classIdsShorten = classIds.filter(id => id);
    const classIdsOnsiteShorten = classIdsOnsite.filter(id => id);

    // ---------------------------------------------- temp solution pull users for weekly bookings ---------------------------------------------//
   
    var firstHalf = [];
    var secondHalf = [];
    var thirdPart = [];
    var forthPart = [];
    var fifthPart = [];
    var sixthPart = [];
    var seventhPart = [];
    var eighthPart = [];
    var ninethPart = [];
    var tenthPart = [];
    var eleventhPart = [];
 
    var IDstringifyPartOne = "";
    var IDstringifyPartTwo = "";
    var IDstringifyPartThree = "";
    var IDstringifyPartFour = "";
    var IDstringifyPartFive = "";
    var IDstringifyPartSix = "";
    var IDstringifyPartSeven = "";
    var IDstringifyPartEight = "";
    var IDstringifyPartNine = "";
    var IDstringifyPartTen = "";
    var IDstringifyPartEleven = "";

    var checksPartTwo = {data:[]};
    var checksPartThree = {data:[]};
    var checksPartFour = {data:[]};
    var checksPartFive = {data:[]};
    var checksPartSix = {data:[]};
    var checksPartSeven = {data:[]};
    var checksPartEight = {data:[]};
    var checksPartNine = {data:[]};
    var checksPartTen = {data:[]};
    var checksPartEleven = {data:[]};


    if (playIdsShorten.length <= 50) {
      IDstringifyPartOne = JSON.stringify(playIdsShorten.concat(partyIdsShorten, classIdsShorten));
    }

    if (playIdsShorten.length > 50 && playIdsShorten.length <= 100) {
      const half = Math.ceil(playIdsShorten.length / 2);    
      firstHalf = playIdsShorten.slice(0, half)
      secondHalf = playIdsShorten.slice(half)
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 100 && playIdsShorten.length <= 150) {
   
      const oneThird = Math.ceil(playIdsShorten.length / 3);
      const twoThird = oneThird*2;       
      firstHalf = playIdsShorten.slice(0, oneThird)
      secondHalf = playIdsShorten.slice(oneThird, twoThird);
      thirdPart = playIdsShorten.slice(twoThird);
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 150 && playIdsShorten.length <= 200) {
      const oneFourth = Math.ceil(playIdsShorten.length / 4);   
      firstHalf = playIdsShorten.slice(0, oneFourth)
      secondHalf = playIdsShorten.slice(oneFourth, oneFourth*2);
      thirdPart = playIdsShorten.slice(oneFourth*2, oneFourth*3);
      forthPart = playIdsShorten.slice(oneFourth*3);
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 200 && playIdsShorten.length <= 250) {
      const divider = Math.ceil(playIdsShorten.length / 5);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4);
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 250 && playIdsShorten.length <= 300) {
    
      const divider = Math.ceil(playIdsShorten.length / 6);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4, divider*5);
      sixthPart = playIdsShorten.slice(divider*5);
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart);
      IDstringifyPartSix = JSON.stringify(sixthPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 300 && playIdsShorten.length <= 350) {
      const divider = Math.ceil(playIdsShorten.length / 7);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4, divider*5);
      sixthPart = playIdsShorten.slice(divider*5, divider*6);
      seventhPart = playIdsShorten.slice(divider*6);
    
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart);
      IDstringifyPartSix = JSON.stringify(sixthPart);
      IDstringifyPartSeven = JSON.stringify(seventhPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 350 && playIdsShorten.length <= 400) {
      const divider = Math.ceil(playIdsShorten.length / 8);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4, divider*5);
      sixthPart = playIdsShorten.slice(divider*5, divider*6);
      seventhPart = playIdsShorten.slice(divider*6, divider*7);
      eighthPart = playIdsShorten.slice(divider*7);
      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart);
      IDstringifyPartSix = JSON.stringify(sixthPart);
      IDstringifyPartSeven = JSON.stringify(seventhPart);
      IDstringifyPartEight = JSON.stringify(eighthPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 400 && playIdsShorten.length <= 450) {
      const divider = Math.ceil(playIdsShorten.length / 9);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4, divider*5);
      sixthPart = playIdsShorten.slice(divider*5, divider*6);
      seventhPart = playIdsShorten.slice(divider*6, divider*7);
      eighthPart = playIdsShorten.slice(divider*7, divider*8);
      ninethPart = playIdsShorten.slice(divider*8);

      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart);
      IDstringifyPartSix = JSON.stringify(sixthPart);
      IDstringifyPartSeven = JSON.stringify(seventhPart);
      IDstringifyPartEight = JSON.stringify(eighthPart);
      IDstringifyPartNine = JSON.stringify(ninethPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 450 && playIdsShorten.length <= 500) {
      const divider = Math.ceil(playIdsShorten.length / 10);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4, divider*5);
      sixthPart = playIdsShorten.slice(divider*5, divider*6);
      seventhPart = playIdsShorten.slice(divider*6, divider*7);
      eighthPart = playIdsShorten.slice(divider*7, divider*8);
      ninethPart = playIdsShorten.slice(divider*8, divider*9);
      tenthPart = playIdsShorten.slice(divider*9);

      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart);
      IDstringifyPartSix = JSON.stringify(sixthPart);
      IDstringifyPartSeven = JSON.stringify(seventhPart);
      IDstringifyPartEight = JSON.stringify(eighthPart);
      IDstringifyPartNine = JSON.stringify(ninethPart);
      IDstringifyPartTen = JSON.stringify(tenthPart.concat(partyIdsShorten, classIdsShorten));
    }
    else if (playIdsShorten.length > 500) {
      const divider = Math.ceil(playIdsShorten.length / 11);   
      firstHalf = playIdsShorten.slice(0, divider)
      secondHalf = playIdsShorten.slice(divider, divider*2);
      thirdPart = playIdsShorten.slice(divider*2, divider*3);
      forthPart = playIdsShorten.slice(divider*3, divider*4);
      fifthPart = playIdsShorten.slice(divider*4, divider*5);
      sixthPart = playIdsShorten.slice(divider*5, divider*6);
      seventhPart = playIdsShorten.slice(divider*6, divider*7);
      eighthPart = playIdsShorten.slice(divider*7, divider*8);
      ninethPart = playIdsShorten.slice(divider*8, divider*9);
      tenthPart = playIdsShorten.slice(divider*9, divider*10);
      eleventhPart = playIdsShorten.slice(divider*10);

      IDstringifyPartOne = JSON.stringify(firstHalf);
      IDstringifyPartTwo = JSON.stringify(secondHalf);
      IDstringifyPartThree = JSON.stringify(thirdPart);
      IDstringifyPartFour = JSON.stringify(forthPart);
      IDstringifyPartFive = JSON.stringify(fifthPart);
      IDstringifyPartSix = JSON.stringify(sixthPart);
      IDstringifyPartSeven = JSON.stringify(seventhPart);
      IDstringifyPartEight = JSON.stringify(eighthPart);
      IDstringifyPartNine = JSON.stringify(ninethPart);
      IDstringifyPartTen = JSON.stringify(tenthPart);
      IDstringifyPartEleven = JSON.stringify(eleventhPart.concat(partyIdsShorten, classIdsShorten));
    }

    // const IDstringify = JSON.stringify(partyIdsShorten.concat(playIdsShorten, classIdsShorten));
    const IDstringifyOnsite = JSON.stringify(partyIdsOnsiteShorten.concat(playIdsOnsiteShorten,classIdsOnsiteShorten));

    const checks = await axios.get(
      config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartOne +'}}}&access_token=' + token
    )
    if (IDstringifyPartTwo.length > 0) {
      checksPartTwo = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartTwo +'}}}&access_token=' + token
      )
    }
    if (IDstringifyPartThree.length > 0) {
      checksPartThree = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartThree +'}}}&access_token=' + token
      )
    }
    if (IDstringifyPartFour.length > 0) {
      checksPartFour = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartFour +'}}}&access_token=' + token
      )
    }
    if (IDstringifyPartFive.length > 0) {
      checksPartFive = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartFive +'}}}&access_token=' + token
      )
    }

    if (IDstringifyPartSix.length > 0) {
      checksPartSix = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartSix +'}}}&access_token=' + token
      )
    }

    if (IDstringifyPartSeven.length > 0) {
      checksPartSeven = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartSeven +'}}}&access_token=' + token
      )
    }

    if (IDstringifyPartEight.length > 0) {
      checksPartEight = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartEight +'}}}&access_token=' + token
      )
    }

    if (IDstringifyPartNine.length > 0) {
      checksPartNine = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartNine +'}}}&access_token=' + token
      )
    }

    if (IDstringifyPartTen.length > 0) {
      checksPartTen = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartTen +'}}}&access_token=' + token
      )
    }

    if (IDstringifyPartEleven.length > 0) {
      checksPartEleven = await axios.get(
        config.serverURL + '/WKUsers?filter={"where":{"id":{"inq":' + IDstringifyPartEleven +'}}}&access_token=' + token
      )
    }


    const checksOnsite = await axios.get(
      config.serverURL + '/OnsiteUsers?filter={"where":{"id":{"inq":' + IDstringifyOnsite +'}}, "include":["membership","guardians"]}&access_token=' + token
    )

    const users = checks.data.concat(checksOnsite.data, checksPartTwo.data, checksPartThree.data, checksPartFour.data, checksPartFive.data, checksPartSix.data, checksPartSeven.data, checksPartEight.data, checksPartNine.data, checksPartTen.data, checksPartEleven.data);
    
    // ---------------------------------------------- temp solution pull users for weekly bookings ---------------------------------------------//


    
    // var { users } = state.users
    var partyBookings = _.cloneDeep(state.bookings.partyBookings)
    var playonlyBookings = _.cloneDeep(state.bookings.playonlyBookings)
    var classBookings = _.cloneDeep(state.bookings.classBookings)

    partyBookings.forEach(party => {
      if (users) {
        users.forEach(user => {
          if (party.onsiteUserId && user.id === party.onsiteUserId) {
            party.user = user
          }

          if (party.wKUserId && user.id === party.wKUserId) {
            party.user = user
          }

          if (!party.user) {
            party.user = {
              firstName: 'Not',
              lastName: 'Found'
            }
          }
        })
      }
    })

    playonlyBookings.forEach(play => {
      users.forEach(user => {
        if (play.onsiteUserId && user.id === play.onsiteUserId) {
          play.user = user
        }

        if (play.wKUserId && user.id === play.wKUserId) {
          play.user = user
        }
      })

      if (!play.user) {
        play.user = {
          firstName: 'Not',
          lastName: 'Found'
        }
      }
    })

    classBookings.forEach(play => {
      users.forEach(user => {
        if (play.onsiteUserId && user.id === play.onsiteUserId) {
          play.user = user
        }

        if (play.wKUserId && user.id === play.wKUserId) {
          play.user = user
        }
      })

      if (!play.user) {
        play.user = {
          firstName: 'Not',
          lastName: 'Found'
        }
      }
    })

    dispatch({
      type: REQUEST_FINISHED,
      property: 'playonlyBookings',
      data: playonlyBookings
    })

    dispatch({
      type: REQUEST_FINISHED,
      property: 'classBookings',
      data: classBookings
    })

    dispatch({
      type: REQUEST_FINISHED,
      property: 'partyBookings',
      data: partyBookings
    })

    dispatch({ type: CHANGE_FINISHED })
  }
}

export const fetchUserBook = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token

    try {
      dispatch({ type: REQUEST_SENT })
      const params = {
        params: {
          filter: {
            where: {
              or: [{ wKUserId: data.id }, { onsiteUserId: data.id }]
            }
          }
        }
      }
      const playonlyBookings = (await axios.get(
        config.serverURL +
          '/PlayOnlyBooking' +
          config.endpoint +
          '?access_token=' +
          token,
        params
      )).data
      const partyBookings = (await axios.get(
        config.serverURL +
          '/PartyBooking' +
          config.endpoint +
          '?access_token=' +
          token,
        params
      )).data

      const classBookings = (await axios.get(
        config.serverURL +
          '/ClassBooking' +
          config.endpoint +
          '?access_token=' +
          token,
        params
      )).data

      const requestedUser = {
        partyBookings: partyBookings,
        playonlyBookings: playonlyBookings,
        classBookings: classBookings
      }

      dispatch({
        type: REQUEST_FINISHED,
        property: 'requestedUser',
        data: requestedUser
      })
      dispatch({ type: CHANGE_FINISHED })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const fetchFinished = data => {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_FINISHED })
  }
}

export const fetchBookingDates = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      var bookingDates = (await axios.get(
        config.serverURL +
          '/BookingDates' +
          config.endpoint +
          '?access_token=' +
          token
      )).data
      dispatch({
        type: FETCH_DATES,
        data: bookingDates
      })
    } catch (error) {
      console.log('bookings - fetchBookingDates:', error.message)
    }
  }
}

export const fetchBookingDates2 = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      var bookingDates = (await axios.get(
        config.serverURL +
          '/PlayOnlyBookingDates' +
          config.endpoint +
          '?access_token=' +
          token
      )).data
      dispatch({
        type: FETCH_DATES2,
        data: bookingDates
      })
    } catch (error) {
      console.log('bookings - fetchBookingDates2:', error.message)
    }
  }
}
